(() => {
  class MainProduct extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.section;
      this.form = qs(`#main-product-form-${this.dataset.section}`);
      this.submitButton = qs('[name="add"]', this.form);
      this.input = qs('#js-main-product-id', this.form);
      this.popup = qs(`#js-mini-popup-${this.sectionId}`);
      this.mediaEl = qs('#js-main-product-current-media-id');
      this.headerCount = qs('#js-header-cart-count');
      this.spinner = qs('.js-main-product-loading', this.submitButton);
      this.mediaSlider = qs('#js-main-product-media-feature');
      this.mediaThumbs = qs('#js-main-product-media-thumbnail');
      this.mediaModal = qs(`#js-main-product-media-modal-${this.dataset.section}`);
      this.modalSlider = qs('#js-main-product-media-modal-slider', this.mediaModal);
      this.zoomButton = qs('.js-main-product-zoom');
      this.closeModalButton = qs('.js-main-product_-media-modal-close', this.mediaModal);
      this.spinnerHidden = 'main-product__loading-spinner--hidden';
      this.mediaModalClass = 'main-product__media-modal--show';

      this.price = qs('.js-main-product__price.main-product__price--no-discount');
  
      this.init();
    }
  
    init() {
      // this.priceLayout();
      this.productForm();
      this.stickyMobileHeader();
      if(this.mediaSlider) {
        this.mediaGallery();
        this.renderMediaModal();
      }
    }

    productForm() {
      qs('#js-main-product-id', this.form).disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.spinner.classList.remove(this.spinnerHidden);
      qs('span', this.submitButton).classList.add('main-product__text--hidden');

      const config = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/javascript` }
      };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      config.body = formData;
      const miniCart = qs('.js-mini-cart');
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            this.handleErrorMessage(data.description);
            this.submitButton.setAttribute('aria-disabled', true);
            qs('span', this.submitButton).classList.add('main-product__text--hidden');
            this.error = true;
            return;
          } else if(!miniCart) {
            window.location = window.routes.cart_url;
            return;
          } 

          this.error = false;
          // if (this.popup) {
          //   this.renderMiniPopup(data);
          // }
          if(miniCart){
            miniCart.classList.add('mini-cart--active');
            scrollLock();
            this.refreshMiniCart();
          }
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          qs('span', this.submitButton).classList.remove('main-product__text--hidden');
          this.spinner.classList.add(this.spinnerHidden);
        });
    }
    refreshMiniCart() {
      const miniCart = qs('.js-mini-cart');
      fetch(window.Shopify.routes.root + '?sections=mini-cart')
        .then((res) => res.json())
        .then((res) => {
          let template = document.createElement('div');
          template.innerHTML = res['mini-cart'];
          let oldContainer = qs('.js-mini-cart__container', miniCart);
          let newContainer = qs('.js-mini-cart__container', template);
  
          oldContainer.innerHTML = newContainer.innerHTML;
        });
    }
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || qs('.js-product-error-message-wrapper', this.form);
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || qs('.js-product-error-message', this.form);

      this.errorMessageWrapper.toggleAttribute('main-product__error-message--hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    renderMiniPopup(data) {
      const totalCart = qs('.js-mini-popup-total-cart', this.popup);
      const productDetails = qs('.js-mini-popup-details', this.popup);
      const closeButtons = qsa('.js-mini-popup-close', this.popup);
      const variants = data.options_with_values;
      const activeClass = 'mini-popup--active';
      let variantItem = '';

      this.popup.classList.add(activeClass);

      for(let i = 0; i <= (variants.length - 1); i++) {
        variantItem += `<li>${variants[i].name}: ${variants[i].value}</li>`
      }

      productDetails.innerHTML = `
        <img src="${data.featured_image.url}" alt="${data.featured_image.alt}">
        <div>
          <h3 class="mini-popup__product-title">${data.product_title}</h3>
          <ul class="mini-popup__product-variants">
            ${variantItem}
          </ul>
        </div>
      `;

      Shopify.theme.cart.getState()
        .then(cart => {
          totalCart.innerText = cart.item_count;
          this.headerCount.innerText = cart.item_count;
        });
    
      closeButtons.forEach(close => {
        close.addEventListener('click', (e) => {
          e.preventDefault();
          this.popup.classList.remove(activeClass);
        })
      })
    }

    mediaGallery() {
      const mediaOptions = this.mediaSlider.dataset.swiper || {};
      const mediaModalOptions = this.modalSlider.dataset.swiper || {};
      const mediaThumbsMobileOptions = this.mediaThumbs.dataset.mobileSwiper || {};
      const mediaThumbsOptions = this.mediaThumbs.dataset.swiper || {};
      
      let sliderModal = new Swiper('#js-main-product-media-modal-slider', {
        slidesPerView: 1,
        loop: true, // required
        allowTouchMove: false,
        ...JSON.parse(mediaModalOptions)
      });

      let thumbs = new Swiper ('#js-main-product-media-thumbnail', {
        threshold: 11, // to prevent the click twice
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        slidesPerView: 'auto',
        spaceBetween: 8,
        ...JSON.parse(mediaThumbsMobileOptions),
        breakpoints: {
          769: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16,
            ...JSON.parse(mediaThumbsOptions),
          }
        }
      });

      let slider = new Swiper('#js-main-product-media-feature', {
        slidesPerView: 1,
        ...JSON.parse(mediaOptions),
        pagination: {
          el: '.js-main-product__media-feature-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: '.js-main-product__media-feature-button--next',
          prevEl: '.js-main-product__media-feature-button--prev'
        },
        thumbs: {
          swiper: thumbs
        }
      });

      slider.controller.control = sliderModal;
      window.addEventListener('resize', () => {
        sliderModal.update();
        slider.update();
      })

      if(this.mediaEl) {
        this.mediaEl.addEventListener('change', (e) => {
          if(e.target.value !== '') {
            slider.slideTo(qs(`#main-product__media-modal-${this.sectionId}-${e.target.value}`).dataset.swiperSlideIndex);
            sliderModal.slideTo(qs(`#main-product__media-modal-${this.sectionId}-${e.target.value}`).dataset.swiperSlideIndex);
          }
        })
      }
    }

    renderMediaModal() {
      if(this.zoomButton) {
        this.zoomButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.mediaModal.classList.add(this.mediaModalClass);
          scrollLock();
        });
      }
      if(this.closeModalButton) {
        this.closeModalButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.mediaModal.classList.remove(this.mediaModalClass);
          scrollLock(false);
        });
      }
    }

    priceLayout() {

      const price = qs('.js-main-product__price.main-product__price--no-discount');
      const priceDiscount = qs('.js-main-product__price.main-product__price--discounted');

      
      if (price !== null) {
        let priceCut = price.innerText.slice(0, -5);
        price.innerHTML= `${priceCut}<sup>${price.innerText.slice(-5)}</sup>`
      }
      
      if (priceDiscount !== null) {
        let discount = priceDiscount.querySelector('span').textContent;
        let priceCut = priceDiscount.innerText.slice(0, -5).replace(discount, '');
        
        priceDiscount.innerHTML= `<span class="main-product__price-compare">${discount}</span> <span>${priceCut}<sup>${priceDiscount.innerText.slice(-5)}</sup></span>`
      }
    }

    sale() {
      
    }

    stickyMobileHeader() {
      const productQuantity = qs('.js-main-product__quantity');
      const productQuantityFixed = 'main-product__quantity--fixed';
      const productCheckoutButton = qs('.js-main-product__checkout-buttons');
      const productCheckoutButtonFixed = 'main-product__checkout-buttons--fixed';
      const breakpoint = window.matchMedia('(max-width: 989px)');

      const mobileStickyAddToCart = () => {
        if (breakpoint.matches) {
          productQuantity.classList.remove(productQuantityFixed);
          productCheckoutButton.classList.remove(productCheckoutButtonFixed);

          if (window.scrollY > 0) {
            productQuantity.classList.add(productQuantityFixed);
            productCheckoutButton.classList.add(productCheckoutButtonFixed);
          }
        }
      };
  
      window.addEventListener('scroll', mobileStickyAddToCart);
      mobileStickyAddToCart();
    }
  }

  customElements.define('main-product', MainProduct);
})();
